(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sv7-card-quickshop"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.sv7QuickshopBound) return;
  window.sv7QuickshopBound = true;
  var sheet = document.getElementById('sv7-quickshop');
  if (!sheet) return;
  var status = sheet.querySelector('[data-qs-status]'), content = sheet.querySelector('[data-qs-content]');
  var options = sheet.querySelector('[data-qs-options]'), add = sheet.querySelector('[data-qs-add]');
  var product, selected = [], active, pending = false, generation = 0, oldOverflow = '';
  function money(value) { return new Intl.NumberFormat('en-IN', {style:'currency', currency:window.Shopify.currency.active || 'INR', maximumFractionDigits:2}).format(value / 100); }
  function update() {
    active = product.variants.find(function (v) { return v.options.every(function (value, i) { return selected[i] === value; }); });
    options.querySelectorAll('button').forEach(function (button) {
      var i = Number(button.dataset.index), value = button.dataset.value;
      button.setAttribute('aria-pressed', String(selected[i] === value));
      // Earlier options constrain later ones; colour remains switchable when a size is sold out.
      button.disabled = pending || !product.variants.some(function (v) { return v.available && v.options[i] === value && v.options.every(function (other, j) { return j >= i || !selected[j] || selected[j] === other; }); });
    });
    add.disabled = pending || !active || !active.available;
    add.textContent = pending ? 'Adding…' : active ? (active.available ? 'Add to bag' : 'Sold out') : 'Select ' + product.options.filter(function(o,i){return !selected[i];}).map(function(o){return o.name.toLowerCase();}).join(' & ');
    var preview = active || product.variants.find(function (v) { return v.options.every(function(value,i){return !selected[i] || value === selected[i];}); });
    if (preview) {
      sheet.querySelector('[data-qs-price]').textContent = money(preview.price);
      var detailLink = sheet.querySelector('[data-qs-details]');
      var detailUrl = new URL(detailLink.href);
      detailUrl.searchParams.set('variant', preview.id);
      detailLink.href = detailUrl.href;
      var img = preview.featured_image && preview.featured_image.src || product.featured_image;
      if (img) sheet.querySelector('[data-qs-image]').src = img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=600';
    }
  }
  sheet.querySelector('[data-qs-close]').addEventListener('click', function(){sheet.close();});
  sheet.addEventListener('click',function(e){if(e.target===sheet){var r=sheet.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)sheet.close();}});
  sheet.addEventListener('close',function(){generation++;document.documentElement.style.overflow=oldOverflow;});
  options.addEventListener('click',function(e){
    var b=e.target.closest('button[data-index]'); if(!b || b.disabled || pending)return;
    var i=Number(b.dataset.index); selected[i]=b.dataset.value;
    for(var j=i+1;j<selected.length;j++) {
      if(!product.variants.some(function(v){return v.available && v.options.every(function(value,k){return k>j || !selected[k] || value===selected[k];});})) selected[j]=null;
    }
    update();
  });
  document.addEventListener('click',async function(e){
    var trigger=e.target.closest('[data-sv7-quickshop]');if(!trigger || pending)return;
    var card=trigger.closest('[data-sv7-card]'), link=card.querySelector('[data-sv7-card-product-link]');
    if(!link)return;
    var url=new URL(link.href), token=++generation;
    status.hidden=false;status.textContent='Loading…';content.hidden=true;add.disabled=true;add.textContent='Loading…';
    oldOverflow=document.documentElement.style.overflow;sheet.showModal();document.documentElement.style.overflow='hidden';
    try {
      var response=await fetch(url.pathname+'.js',{credentials:'same-origin'});
      if(!response.ok)throw new Error('Unable to load this product. Please try again.');
      var data=await response.json();if(token!==generation || !sheet.open)return;
      product=data;selected=product.options.map(function(o){return o.values.length===1 ? o.values[0] : null;});
      var swatch=card.querySelector('[data-sv7-card-swatch][aria-pressed="true"]');
      if(swatch)selected[Number(swatch.dataset.optionPosition)-1]=swatch.dataset.optionValue;
      options.replaceChildren();
      product.options.forEach(function(o,i){
        if(o.name==='Title' && o.values.length===1)return;
        var field=document.createElement('fieldset'),legend=document.createElement('legend'),values=document.createElement('div');
        legend.textContent=o.name;values.className='sv7-qs__values';field.append(legend,values);
        o.values.forEach(function(value){var b=document.createElement('button');b.type='button';b.textContent=value;b.dataset.index=i;b.dataset.value=value;b.setAttribute('aria-pressed','false');values.append(b);});options.append(field);
      });
      sheet.querySelector('h2').textContent=product.title;sheet.querySelector('[data-qs-image]').alt=product.title;
      sheet.querySelector('[data-qs-details]').href=url.href;
      var rating=card.querySelector('.rrc-image-rating'),review=sheet.querySelector('[data-qs-reviews]');
      review.hidden=!rating;if(rating){review.textContent=rating.textContent.trim()+' · Read reviews';review.href=rating.href;}
      status.hidden=true;content.hidden=false;update();sheet.querySelector('.sv7-qs__body').scrollTop=0;
    } catch(error) {if(token!==generation)return;status.hidden=false;status.textContent=error.message;add.textContent='Try opening again';}
  });
  add.addEventListener('click',async function(){
    if(pending || !active || !active.available)return;
    if(!window.sv7 || !window.sv7.cart){status.hidden=false;status.textContent='Bag is still loading. Please try again.';return;}
    pending=true;var token=generation;update();
    try{await window.sv7.cart.add(active.id,1);if(token===generation && sheet.open){sheet.close();window.sv7.openDialog('sv7-cart-drawer');}}
    catch(error){if(token===generation){status.hidden=false;status.textContent=error.message || 'Could not add to bag. Please try again.';}}
    finally{pending=false;if(token===generation)update();}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
